import styled from 'styled-components'

export const Container = styled.div`
  padding: 16px;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  
  div{
    width: calc(100% - 270px);
    margin-left: 8px;
    h5{
      font-size: 20px;
      line-height: 1.5;
    }
    p{
      font-size: 16px;
      line-height: 1.5;
    }
  }
  img{
    width: 150px;
    max-width: 240px;
  }
  @media (min-width: 700px){
    flex-grow: 0;
    max-width: 100%;
    flex-basis: 100%;
  }
  @media (min-width: 960px){
    flex-grow: 0;
    max-width: 50%;
    flex-basis: 50%;
  }
  @media screen and (max-width: 599px){
    div{

      width: 100%;
      text-align: center;
    }
}
`